/*
 * Description  :
 * Date         :2021-11-01 14:02:38
 * LastEditors  :chenjia
 * LastEditTime :2021-12-14 17:56:45
 * FilePath     :\abackup-pay\src\service\httpService.js
 */
import axios from 'axios'
import qs from 'qs'


// post 请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

if(process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api'
} else if(process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'https://pay.abackup.com/api/v1/'
}

// 请求拦截器
axios.interceptors.request.use(config => {
  // const sessionid = Cookies.get('sessionid')
  // sessionid && (config.headers.sessionid = sessionid)
  return config
})

// 响应拦截器
axios.interceptors.response.use(resp => {
  console.log(resp,'________________________')
  return resp
})

/**
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
 export function ajaxGet(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} data [请求时携带的参数] 
*/
export function ajaxPost(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(data))
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}